import { render, staticRenderFns } from "./AgentesRecaudacion.vue?vue&type=template&id=7af4e9c5&"
import script from "./AgentesRecaudacion.vue?vue&type=script&lang=js&"
export * from "./AgentesRecaudacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports